import styled from "styled-components";
import CheckboxCheckmark from "./CheckboxCheckmark";

export default styled.label`
  // display: flex;
  // align-items: center;
  // position: relative;
  // margin: 1rem 2rem;
  // cursor: pointer;
  // font-size: 1rem;
  // user-select: none;
  // height: 5.4rem;

  display: inline-block;
  position: relative;
  z-index: 1;
  border-radius: 40px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    & > input ~ ${CheckboxCheckmark} {
      border: 1px solid #ff5c4d;
      color: #ff5c4d;
    }
  }
`;
